import React, { useState } from "react";
import { Button, Col, Input, message, Modal, Row } from "antd";

import { COLORS } from "../../../config/theme";
import { request } from "../../../config/API";
import { SketchPicker } from "react-color";
const BUTTON_COLORS = ["#a5be00", "#9c7178", "#20063b", "#cc3363"];
const ProfileManagementModal = ({
  profileManagementModal,
  setProfileManagementModal,
  profiles,
  qrLink,
  getQrCode,
  setShowSetupProfileModal,
}) => {
  const [error, setError] = useState("");
  const { primaryDark } = COLORS;
  const selectedProfile = profiles.find(
    (item) => item.profileIndex.toString() === profileManagementModal
  );
  const [buttonColor, setButtonColor] = useState(
    BUTTON_COLORS[selectedProfile?.profileIndex]
  );
  const [profileName, setProfileName] = useState(selectedProfile?.profileName);
  const [changeColor, setChangeColor] = useState(false);
  const [changeName, setChangeName] = useState(false);

  const handleProfileNotExists = () => {
    setError("Please setup this profile first");
  };
  const onClickChooseProfile = () => {
    if (!selectedProfile) {
      handleProfileNotExists();
      return;
    }
    request
      .put(`qr/changeQrProfile/${selectedProfile.key}`)
      .then((res) => {
        getQrCode(res.data.qrId);
        setProfileManagementModal("");
      })
      .catch((err) => {
        console.error(err.response);
        message.error(err?.response?.data?.data || "Please Try Again");
        // setIsRemoving(false);
      });
  };
  const onClickChangeName = () => {
    if (!selectedProfile) {
      handleProfileNotExists();
      return;
    }
    setChangeColor(false);
    setProfileName(selectedProfile?.profileName);
    setChangeName((prev) => !prev);
  };
  const onClickChangeColor = () => {
    if (!selectedProfile) {
      handleProfileNotExists();
      return;
    }
    setChangeName(false);
    setButtonColor(BUTTON_COLORS[selectedProfile?.profileIndex]);
    setChangeColor((prev) => !prev);
  };
  const onClickSetupProfile = () => {
    setShowSetupProfileModal(profileManagementModal);
  };

  const handleSaveColor = () => {
    request
      .put(`qr/changeQrProfileButtonColor/${selectedProfile.key}`, {
        buttonColor,
      })
      .then((res) => {
        getQrCode(qrLink);
        setProfileManagementModal("");
      })
      .catch((err) => {
        console.error(err.response);
        message.error(err?.response?.data?.data || "Please Try Again");
      });
  };
  const handlerSaveProfileName = () => {
    if (profileName.length > 20) {
      return setError("more than 20 characters are not allowed");
    }
    request
      .put(`qr/changeQrProfileName/${selectedProfile.key}`, {
        profileName,
      })
      .then((res) => {
        getQrCode(qrLink);
        setProfileManagementModal("");
      })
      .catch((err) => {
        console.error(err.response);
        message.error(err?.response?.data?.data || "Please Try Again");
      });
  };

  return (
    <Modal
      title="Profile Management Modal"
      visible={profileManagementModal}
      footer={null}
      onCancel={() => setProfileManagementModal("")}
      centered={true}
    >
      <Col span={24} style={{ margin: "1rem 0" }}>
        <Row span={24}>
          <Col span={12} align="middle">
            <Button
              shape="round"
              type="primary"
              style={{
                background: primaryDark,
                borderColor: primaryDark,
              }}
              onClick={onClickChooseProfile}
            >
              Choose Profile
            </Button>
          </Col>
          <Col span={12} align="middle">
            <Button
              shape="round"
              type="primary"
              style={{
                background: primaryDark,
                borderColor: primaryDark,
              }}
              onClick={onClickSetupProfile}
            >
              Setup Profile
            </Button>
          </Col>
        </Row>
        <Row span={24} style={{ margin: "1rem 0" }}>
          <Col span={12} align="middle">
            <Button
              shape="round"
              type="primary"
              style={{
                background: primaryDark,
                borderColor: primaryDark,
              }}
              onClick={onClickChangeName}
            >
              Change Name
            </Button>
          </Col>
          <Col span={12} align="middle">
            <Button
              shape="round"
              type="primary"
              style={{
                background: primaryDark,
                borderColor: primaryDark,
              }}
              onClick={onClickChangeColor}
            >
              Change Color
            </Button>
          </Col>
        </Row>

        {changeColor && (
          <Row span={24} style={{ margin: "1rem 0" }}>
            <Col span={12} align="middle">
              <SketchPicker
                color={buttonColor}
                onChange={(e) => setButtonColor(e.hex)}
              />
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                shape="round"
                type="primary"
                style={{
                  width: "10rem",
                  background: buttonColor,
                  borderColor: buttonColor,
                }}
                onClick={handleSaveColor}
              >
                Save
              </Button>
            </Col>
          </Row>
        )}
        {changeName && (
          <Row span={24} style={{ margin: "1rem 0" }}>
            <Col span={12} align="middle">
              <Input
                size="large"
                name="email"
                value={profileName}
                onChange={(e) => {
                  if (e.target.value.length < 20) {
                    setError("");
                  }
                  setProfileName(e.target.value);
                }}
                style={{ borderRadius: 8 }}
                placeholder="Profile Name"
              />
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                shape="round"
                type="primary"
                style={{
                  width: "10rem",
                  background: primaryDark,
                  borderColor: primaryDark,
                }}
                onClick={handlerSaveProfileName}
              >
                Save
              </Button>
            </Col>
          </Row>
        )}
        {!!error && (
          <p style={{ color: "red", textAlign: "center", fontWeight: "500" }}>
            {error}
          </p>
        )}
      </Col>
    </Modal>
  );
};
export default ProfileManagementModal;
